import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthProvider } from "../contexts/Auth";
import { Signup } from "../containers/Signup";
import { Login } from "../containers/Login";
import { Dashboard } from "../containers/Dashboard";
import { PrivateRoute } from "../containers/PrivateRoute";
function App() {
  return (
    <div className="app-root">
      <Router>
        <AuthProvider>
          <Switch>
            <PrivateRoute exact path="/" component={Dashboard} />
            <PrivateRoute
              exact
              path="/sessionDetails/:sessionId/:version"
              component={Dashboard}
            />
            <Route path="/signup" component={Signup} />
            <Route path="/login" component={Login} />
          </Switch>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
